import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import { TABLE_HEADERS, keyMapping } from '../../../../../constants/LeadStatus'; 
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { toastSuccess } from '../../../../customComponents/customToast/Toast';
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { ToastContainer } from 'react-toastify';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';
const LeadStatusList = () => {
  const [leadStatuses, setLeadStatuses] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)

  const token = localStorage.getItem("authToken");
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchLeadStatuses(newPage);
  };

  const fetchLeadStatuses = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/status/list', {
        
        orderBy: 'status_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setLeadStatuses(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
      //toastSuccess("Product Data fetched successfully!");
    } catch (error) {
      console.error('Error fetching lead statuses:', error);
    }
    finally{
setLoading(false)
    }
  };

  useEffect(() => {
    if (searchTerm === "") {
      fetchLeadStatuses();
    }
  }, [searchTerm]);
  const handleEditButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITLEADSTATUS}`, { state: { data: rowData } });
    // console.log("rowdata", rowData)
  }

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h5>Lead Status Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText"  >{totalData} </h5>
            <h6>All Lead Status</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText"  >{totalActive} </h5>
            <h6>Active Lead Status</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText"  >{totalInactive} </h5>
            <h6>Inactive Lead Status</h6>
          </div>
          <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-lead/lead-status/add-lead-status')}>
            Add Lead Status
          </button>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
        <div className='listsearchContainer'>
          <h5>Lead Status List</h5>
          <div>
              <SearchInput
                placeholder="Search Departments"
                onSearch={fetchLeadStatuses}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        
        </div>

        <CustomTable data={leadStatuses} headers={TABLE_HEADERS} keyMapping={keyMapping} 
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          totalRecords={totalRecords} 
         onEdit={handleEditButton} />
      </div>
    </div>
      )}
  </div>
  );
};

export default LeadStatusList;
